export default "__VITE_ASSET__DoOhhFwS__"